import type { DataResponse } from '@/types/data'
import apiClient from './client'

export async function fetchData(): Promise<DataResponse> {
  return apiClient.get<DataResponse>('/data')
}
